import { InjectionToken } from '@angular/core';

export const WIDGET_PREVIEW_MODE = new InjectionToken('', {
    factory: () => false,
});
